import { createTheme } from '@mui/material/styles';
import { brightThemeProps } from '../brightThemeProps';
import { deDE } from '@mui/material/locale';

export const brightThemeDE = createTheme(brightThemeProps, deDE);
